import { TRACKERS } from "@/constants/Trackers";
import { LiveQueue } from "@/features/LiveQueue/LiveQueue";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/live-queue")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_QUEUE);
  },
});

function RouteComponent() {
  return <LiveQueue />;
}
